import { useEffect } from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

import useStartLogin from '../hooks/api/useStartLogin';
import type { IOAuth2Config } from '../utils/types';

interface ILoginPageProps {
  config: IOAuth2Config;
  onError?: (error: unknown) => void;
  unauthorizedRedirectUrl?: string;
}

const LoginPage: React.FC<ILoginPageProps> = ({
  config,
  onError,
  unauthorizedRedirectUrl,
}) => {
  const { startLogin } = useStartLogin({ config, onError });

  useEffect(() => {
    if (unauthorizedRedirectUrl) {
      window.location.href = unauthorizedRedirectUrl;
    } else {
      startLogin();
    }
  }, []);

  return (
    <WrapperDiv>
      <Spin
        size="large"
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </WrapperDiv>
  );
};

export default LoginPage;

const WrapperDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f7f9;
  width: 100%;
`;
